import axios from 'axios';
import React, { useContext } from 'react';
import { ProductContext } from '../../App';

function AddPayment(props) {

    const product_context = useContext(ProductContext);
    const { setIsLoading, alert, setAlert } = product_context;

    const { addPaymnet, setAddPayment, reload } = props;

    const { isOpen, status } = addPaymnet;

    const handlePaymentSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        let data = {
            name: e.target.name.value,
            amount: e.target.amount.value,
            status: status,
        }

        axios.post(`${process.env.REACT_APP_SERVER_DOMAIN}/payment`, data)
            .then(res => {
                setAlert({
                    isOpen: true,
                    message: "Payment Inserted",
                    type: 'success'
                });
                setAddPayment({ ...addPaymnet, isOpen: false });
                setIsLoading(false);
                reload();
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something went wrong",
                    type: 'danger'
                });
                setIsLoading(false);
            })

        setTimeout(() => {
            setAlert({ ...alert, isOpen: false })
        }, 5000);
    }

    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2>Add Payment</h2>
                    <div className="edit-form">
                        <form onSubmit={handlePaymentSubmit}>

                            <div className="inputs">
                                <label htmlFor="name">Name</label>
                                <input type="text"

                                    required
                                    placeholder='Enter Name' name='name'
                                />
                            </div>

                            <div className="inputs">
                                <label htmlFor="amount">Amount</label>
                                <input type="number"

                                    required
                                    placeholder='Enter Amount' name='amount'
                                />
                            </div>
                            <div>
                                <button type='submit' className='btn btn-success mx-2'>Submit</button>
                                <button onClick={() => {
                                    setAddPayment({ ...addPaymnet, isOpen: false });
                                }} className='btn btn-danger'>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> : null}
        </>
    )
}

export default AddPayment;
